/**
 * FE-C2c/C2d: fleet-wide device_acl shares — cursor pagination via contract path.
 */

import { buildContractPath } from "./api/contract-client.js";

export const ADMIN_SHARES_PAGE_LIMIT = 500;

/** @type {((path: string, opts?: object) => Promise<unknown>) | null} */
let _api = null;

/**
 * @param {(path: string, opts?: object) => Promise<unknown>} apiFn
 */
export function bindAdminSharesApi(apiFn) {
  _api = apiFn;
}

/**
 * @param {unknown} body
 * @returns {boolean}
 */
export function isPaginatedAdminSharesBody(body) {
  return !!(body && typeof body === "object" && body.page && typeof body.page === "object");
}

/**
 * @param {{
 *   query?: Record<string, string | number | boolean | null | undefined>,
 *   limit?: number,
 *   timeoutMs?: number,
 *   activeOnly?: boolean,
 * }} [opts]
 * @returns {Promise<{ items: object[] }>}
 */
export async function fetchAllAdminShares(opts = {}) {
  if (!_api) throw new Error("fetchAllAdminShares: api not bound");
  const limit = Number.isFinite(Number(opts.limit)) ? Number(opts.limit) : ADMIN_SHARES_PAGE_LIMIT;
  const timeoutMs = Number.isFinite(Number(opts.timeoutMs)) ? Number(opts.timeoutMs) : 20000;
  const activeOnly = opts.activeOnly !== false;
  const baseQuery = { ...(opts.query || {}) };

  const merged = [];
  let cursor = null;
  let paginated = null;

  for (;;) {
    const query = { ...baseQuery, limit };
    if (cursor) query.cursor = cursor;
    const path = buildContractPath("get__admin_shares", { query });
    const body = await _api(path, { timeoutMs });
    if (paginated === null) paginated = isPaginatedAdminSharesBody(body);
    const items = body && Array.isArray(body.items) ? body.items : [];
    merged.push(...items);
    if (!paginated) break;
    const page = body && body.page && typeof body.page === "object" ? body.page : {};
    if (!page.has_more) break;
    const next = page.next_cursor != null ? String(page.next_cursor) : "";
    if (!next) break;
    cursor = next;
  }

  const out = activeOnly ? merged.filter((x) => x && !x.revoked_at) : merged.filter(Boolean);
  return { items: out };
}
